<template>
    <main class="page page-dashboard">
        <div class="container">

            <PageHeader
                :title="$translate.text('general.customer_group')"
            />

            <ConnectionMenu></ConnectionMenu>

            <div v-if="connection.webshop_type === 'woocommerce'">
                <Alert>{{ t('alert.combine.customergroups.woocommerce') }}</Alert>
            </div>

            <form @submit.prevent="submitForm" method="POST">
                <h4>{{ t('clients.connections.general') }}</h4>

                <Select
                    id="brands"
                    :value="customerGroup.brand_id"
                    name="brands"
                    @change="customerGroup.brand_id = $event"
                    :options="brandsSelectValues"
                    :label="$translate.text('general.brand')"
                    :required="false"
                    :loading="!brandsLoaded || !connectionLoaded"
                />

<!--                <Select-->
<!--                    id="categories"-->
<!--                    :value="customerGroup.category_id"-->
<!--                    name="categories"-->
<!--                    @change="customerGroup.category_id = ($event === '' ? null : parseInt($event,10))"-->
<!--                    :options="categoriesSelectValues"-->
<!--                    :label="$translate.text('general.category')"-->
<!--                    :required="false"-->
<!--                    :loading="!categoriesLoaded || !connectionLoaded"-->
<!--                />-->

                <div class="form-group">
                    <label for="categories">{{ $translate.text('general.categories') }}
                        <i style="font-size: 14px;"></i>
                    </label>

                    <Multiselect
                        v-model="customerGroup.categories"
                        :options="categoriesSelectValues"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :placeholder="this.$translate.text('general.select_all')"
                        label="label"
                        track-by="value"
                        open-direction="bottom"
                        id="categories"
                    >
                        <!-- <template slot="selection" open-direction="bottom" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> -->
                    </Multiselect>
                </div>

                <Select
                    id="customerGroups"
                    :value="customerGroup.customer_group_id"
                    name="customerGroups"
                    @change="customerGroup.customer_group_id = $event"
                    :options="customerGroupsSelectValues"
                    :label="$translate.text('general.customer_groups')"
                    :required="true"
                    :loading="!customerGroupsLoaded"
                />

                <Select
                    id="rule"
                    v-if="connection.webshop_type === 'shopware6'"
                    :value="customerGroup.rule_id"
                    name="rule"
                    @change="customerGroup.rule_id = $event"
                    :options="rulesSelectValues"
                    :label="$translate.text('general.rule')"
                    :required="true"
                    :loading="!rulesLoaded"
                />

                <Select
                    id="use_b2b"
                    :value="customerGroup.use_b2b"
                    name="use_b2b"
                    @change="customerGroup.use_b2b = parseInt($event, 10)"
                    :options="use_b2b_options"
                    :label="$translate.text('clients.connection.customergroup.type')"
                    :required="true"
                />

                <NumberInput
                    v-if="customerGroup.use_b2b === 0"
                    id="marge"
                    :value="customerGroup.value"
                    name="marge"
                    @change="customerGroup.value= parseInt($event, 10)"
                    :label="$translate.text('clients.connection.customergroup.discount')"
                    :required="true"
                />

                <Select
                    v-if="customerGroup.use_b2b === 1"
                    id="feedvalue"
                    :value="customerGroup.feed_name"
                    name="feed_name"
                    @change="customerGroup.feed_name = $event"
                    :options="feedvaluesSelectValues"
                    :label="$translate.text('general.field')"
                    :required="true"
                    :loading="!feedValuesLoaded"
                />

                <Select
                    v-if="customerGroup.use_b2b === 1"
                    id="b2b_inc"
                    :value="customerGroup.b2b_inc"
                    name="b2b_inc"
                    @change="customerGroup.b2b_inc = parseInt($event, 10)"
                    :options="b2b_inc_options"
                    :label="$translate.text('clients.connection.customergroup.b2b_inc')"
                    :required="true"
                />

                <FormSubmit
                    :routeAfterCancelLink="{ name: 'Clients Connections Customer Groups' }"
                    :buttonLabel="submittingIsLoading ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                    :disabled="submittingIsLoading"
                />
            </form>
        </div>
    </main>
</template>
<script>
import Multiselect from 'vue-multiselect';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import NumberInput from '@/components/Inputs/NumberInput';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';
import Alert from '@/components/Alert/Alert.vue';

export default {
    name: 'ClientAddCustomerGroup',

    components: {
        Alert,
        ConnectionMenu,
        PageHeader,
        NumberInput,
        Select,
        FormSubmit,
        Multiselect,
    },

    data() {
        return {
            customerGroup: {
                brand_id: null,
                category_id: null,
                categories: [],
                customer_group_id: null,
                value: 0,
                use_b2b: 0,
                feed_name: null,
                b2b_inc: 0,
            },

            connection: [],
            connectionLoaded: false,

            webshopcategories: [],
            webshopcategoriesLoaded: false,

            customerGroups: [],
            customerGroupsLoaded: false,

            rules: [],
            rulesLoaded: false,

            brands: [],
            brandsLoaded: false,

            categories: [],
            categoriesLoaded: false,

            use_b2b_options: [
                { label: this.$translate.text('general.discount'), value: 0 },
                { label: this.$translate.text('clients.connection.customergroup.options.business_to_business_price'), value: 1 },
            ],

            b2b_inc_options: [
                { label: this.$translate.text('general.no'), value: 0 },
                { label: this.$translate.text('general.yes'), value: 1 },
            ],

            submittingIsLoading: false,

            feedvalues: [],
            feedValuesLoaded: false,
        };
    },

    created() {
        this.getConnection();
    },

    methods: {
        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    const connection = response.data.data;

                    connection.active = connection.active === 1;
                    connection.vat_calculate = connection.vat_calculate === 1;
                    connection.content_provider.active = connection.content_provider.active === 1;

                    this.connection = connection;

                    this.connectionLoaded = true;

                    this.getCombinedBrands();
                    this.getCombinedCategories();
                    this.getWebshopCategories();
                    this.getCustomerGroups();

                    if (this.connection.webshop_type === 'shopware6') {
                        this.getRules();
                    }

                    this.getFeedvalues();
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombinedBrands() {
            this.API.clients.connections.brands.getCombined(this.$route.params.id)
                .then(response => {
                    this.brands = response.data.data;
                    this.brandsLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombinedCategories() {
            this.API.clients.connections.categories.getCombined(this.$route.params.id)
                .then(response => {
                    this.categories = response.data.data;
                    this.categoriesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getWebshopCategories() {
            if (this.connection.configbase === 'webshop') {
                this.API.clients.connections.categories.getItemsFromWebshop(this.connection.id)
                    .then(response => {
                        this.webshopcategories = response.data;
                        this.webshopcategoriesLoaded = true;
                    }).catch(error => {
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            } else {
                this.webshopcategoriesLoaded = true;
            }
        },

        getCustomerGroups() {
            this.API.clients.connections.customerGroups.getCustomerGroups(this.$route.params.id)
                .then(response => {
                    this.customerGroups = response.data;
                    this.customerGroupsLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getRules() {
            this.API.clients.connections.customerGroups.getRules(this.$route.params.id)
                .then(response => {
                    this.rules = response.data;
                    this.rulesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getFeedvalues() {
            this.API.clients.feeds.combine.values(this.connection.feed_id)
                .then(response => {
                    this.feedvalues = response.data;
                    this.feedValuesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            this.submittingIsLoading = true;

            this.API.clients.connections.customerGroups.store(this.$route.params.id, this.customerGroup)
                .then(() => {
                    this.submittingIsLoading = false;
                    this.$router.push({ name: 'Clients Connections Customer Groups' });
                    this.resetForm();
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        resetForm() {
            this.customerGroup = {
                brand_id: null,
                category_id: null,
                customer_group_id: null,
                value: 0,
                use_b2b: 0,
                feed_name: null,
            };
        },

        findCategoryNameById(categories, id, name = null) {
            categories.forEach(category => {
                if (category.id === id) {
                    name = category.name;
                }

                if (category.children) {
                    name = this.findCategoryNameById(category.children, id, name);
                }
            });

            return name;
        },
    },

    computed: {
        brandsSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_all'), value: null },
            ];

            this.brands.forEach(brand => {
                values.push({
                    value: brand.id,
                    label: brand.feed_name,
                });
            });

            return values;
        },

        categoriesSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_all'), value: null },
            ];

            this.categories.forEach(category => {
                values.push({
                    value: category.id,
                    label: this.connection.configbase === 'feed' ? category.feed_name : this.findCategoryNameById(this.webshopcategories, category.webshop_id),
                });
            });

            return values;
        },

        customerGroupsSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_option'), value: null, disabled: true },
            ];

            this.customerGroups.forEach(customerGroup => {
                values.push({
                    value: customerGroup.id,
                    label: customerGroup.name,
                });
            });

            return values;
        },

        rulesSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_option'), value: null, disabled: true },
            ];

            this.rules.forEach(rule => {
                values.push({
                    value: rule.id,
                    label: rule.name,
                });
            });

            return values;
        },

        feedvaluesSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_option'), value: null, disabled: true },
            ];

            this.feedvalues.forEach(feedvalue => {
                values.push({
                    value: feedvalue.key,
                    label: feedvalue.key,
                });
            });

            return values;
        },
    },


};
</script>
<style lang="scss" scoped>
.form-group {
    display: flex;
    align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    .multiselect {
        -webkit-box-flex: 6;
        -ms-flex: 6;
        flex: 6;
        // height: 42px;
        font-size: 16px;
        border: 0;
        background-color: white;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        padding: 0 16px;
    }


}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
